document.addEventListener('DOMContentLoaded', () => {

    // SCROLL
    function scroll(elem, indent, duration) {
        indent = typeof indent == 'number' ? indent : 0;
        duration = typeof duration == 'number' ? duration : 400;

        let startPos = document.documentElement.scrollTop || document.body.scrollTop,
            finishPos = elem ? elem.getBoundingClientRect().top + pageYOffset - indent : 0,
            diffPos = finishPos - startPos,
            startTime = new Date().getTime(),
            finishTime = startTime + duration;

        let anim = setInterval( () => {
            let currentTime = new Date().getTime(),
                newPos;

            if (currentTime >= finishTime) {
                newPos = finishPos;
                clearInterval(anim);
            } else {
                let diffTime = finishTime - currentTime,
                    diffPrc =  diffTime / duration;
                newPos = finishPos - (diffPos * diffPrc);
            }

            window.scrollTo(0, newPos);
        },10);
    }

    const goTo = document.querySelectorAll('.js-goTo');

    goTo.forEach(item => {
        const elem = document.querySelector(item.hash);

        item.addEventListener('click', e => {
            e.preventDefault();
            scroll(elem);
        });
    });

    // BURGER
    const burger = document.querySelector('.js-burger');
    const nav = document.querySelector('.js-nav');

    burger.addEventListener('click', () => {
        burger.classList.toggle('is-active');
        nav.classList.toggle('is-hidden');
    });
});
